module.exports = __webpack_public_path__ + "img/sidebar-fold-in-icon.efc2045e.png";